export default __webpack_public_path__ + "static/media/jumping1.a1ecf2c2.jpg";